module.exports = __webpack_public_path__ + "img/16200.2fb9649a.jpg";